import Axios from 'config/axios';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateConstant } from 'store/actions/constantAction';

const url = '/api/v5/groups/student-groups';
let loading = false;

const useStudentGroups = () => {
    const GROUPS = useSelector((state) => state.constants.groups);
    const dispatch = useDispatch();

    const [groups, setGroups] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            if (GROUPS) {
                setGroups(GROUPS);
            } else {
                if (loading) return;
                loading = true;
                const response = await Axios.get(url);
                const data = response.data;
                dispatch(updateConstant('groups', data));
                setGroups(data);
                loading = false;
            }
        };

        fetchData();
    }, [GROUPS, dispatch]);

    const updateGroups = (data) => {
        if (!Array.isArray(data)) {
            data = [data];
        }
        const updatedGroups = groups.map((group) => {
            if (group.groupId === data.groupId) {
                return { ...group, ...data };
            }
            return group;
        });
        const newGroups = data.filter((group) => !updatedGroups.find((g) => g.groupId === group.groupId));
        setGroups([...updatedGroups, ...newGroups]);
        dispatch(updateConstant('groups', [...updatedGroups, ...newGroups]));
    };

    return [groups, updateGroups];
};

export default useStudentGroups;
